import { render, staticRenderFns } from "./DecView.vue?vue&type=template&id=71f418fe&scoped=true&"
import script from "./DecView.vue?vue&type=script&lang=js&"
export * from "./DecView.vue?vue&type=script&lang=js&"
import style0 from "./DecView.vue?vue&type=style&index=0&id=71f418fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f418fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
